import { Fragment } from "react";

function TableRow({
  tableName,
  index,
  columns,
  row,
  actions,
  internalOrderFields,
  hasSapDownloadButtons,
  hasSapConfirmButtons,
  array,
  highlightedRows,
  highlightedRowColors,
}) {
  const highlightTrStyles = {
    background: highlightedRowColors?.background,
  };

  const highlightTdStyles = {
    color: highlightedRowColors?.color,
  };

  const isHighlighted = highlightedRows?.some((highlightedRow) => {
    if (highlightedRow.id) {
      return highlightedRow.id === row.id;
    }
    if (highlightedRow.application_id) {
      return highlightedRow.application_id === row.application_id;
    }
  });

  return (
    <Fragment key={row.id}>
      <tr
        id={tableName + "-table-row-" + index}
        className="table-row align-middle"
        data-name="table-row"
        style={isHighlighted ? highlightTrStyles : {}}
      >
        {columns.map((column) => {
          const action = actions?.find(
            (action) => action.accessor === column.accessor
          );

          const internalOrdersData = row?.internal_orders?.data;
          const internalOrdersString = internalOrdersData
            ?.slice(0, internalOrderFields.length)
            .map(({ number }, idx, arr) => {
              if (idx !== arr.length - 1) return number + ", ";
              else return number;
            });
          const isInternalOrderField =
            column.accessor === "internal_orders" && internalOrderFields.length;

          return (
            <td
              key={
                isInternalOrderField ||
                (column.format && column.accessor === "internal_orders")
                  ? "internal_orders"
                  : column.accessor
              }
              style={isHighlighted ? highlightTdStyles : {}}
            >
              {action?.action && action.action(row)}

              {column.format && column.format(row[column.accessor])}

              {isInternalOrderField && internalOrdersString}

              {column.format &&
                column.accessor === "internal_orders" &&
                column.format(internalOrdersData[0]?.number)}
              {row[column.accessor] || action !== undefined
                ? row[column.accessor]
                : "——"}
            </td>
          );
        })}
      </tr>
    </Fragment>
  );
}
export default TableRow;
